export const notificationConstants = {
  PUSH_NOTIFICATION: '[Notification] Push notification',
  REMOVE_NOTIFICATION: '[Notification] Remove notification'
}
